import React from "react";
import {ArchiveBoxIcon, ClockIcon, UserIcon} from "@heroicons/react/24/outline";
import { ReactComponent as PFC } from "../customIcons/PFC.svg";
import {useDarkMode} from "../contexts/darkModeContext";
import {salesIDMapping} from "./GLOBAL/GlobalFunctions";

const PlantLoading = ({ status }) => {
    
    const {darkMode} = useDarkMode();
    
    if (!status.running) return null; // don’t show when not running

    const progress = status.progress ?? 0;

    return (
        <div className={`fixed inset-0 z-50 flex items-start justify-center pointer-events-none`}>
            <div
                className={`mt-4 w-[90%] max-w-md rounded-full px-4 py-3 flex items-center gap-4 ${
                    darkMode
                        ? "bg-darkMainColor text-white shadow-2xl shadow-green-600"
                        : "bg-white text-gray-900"
                } shadow-sm backdrop-blur`}
            >
                {/* Progress Ring */}
                <div className="relative size-8 shrink-0">
                    <svg className="size-8 -rotate-90">
                        <circle
                            cx="16"
                            cy="16"
                            r="14"
                            stroke={darkMode ? "rgba(255,255,255,0.15)" : "#e5e7eb"}
                            strokeWidth="3"
                            fill="none"
                        />
                        <circle
                            cx="16"
                            cy="16"
                            r="14"
                            stroke="#16a34a"
                            strokeWidth="3"
                            fill="none"
                            strokeDasharray={88}
                            strokeDashoffset={88 - (88 * (progress / 2)) / 100}
                            className="transition-all duration-500 ease-out"
                        />
                    </svg>
                </div>

                {/* Text */}
                <div className="flex-1 min-w-0">
                    <div className="text-xs font-medium truncate">
                        {status.message || "Working"}
                    </div>
                    <div className="text-[10px] text-gray-500 truncate">
                        {salesIDMapping[status.currentRep] || "Processing"}
                    </div>
                </div>

                {/* Timer */}
                <div className="text-[10px] font-mono text-green-600">
                    {status.elapsed}s
                </div>
            </div>
        </div>
    );
};

export default PlantLoading;
